import { Component, OnDestroy, OnInit, OnChanges, EventEmitter, Input, Output, ViewContainerRef, ViewChild} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import {Location} from '@angular/common';
import { UserFull } from '../../../shared/models/userFull.model';

import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
 import {Observable, Subject, map, Subscription} from 'rxjs';

// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { DatePipe } from '@angular/common';
import { FileUploadsModalComponent } from './../../../manager/file-uploads-modal/file-uploads-modal.component';
import {UserAvitarModalUploadComponent} from './../user-avitar-modal-upload/user-avitar-modal-upload.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { ToolbarService } from '@syncfusion/ej2-angular-grids';
import { LinkService, ImageService, HtmlEditorService, TableService, FileManagerService, InsertHtml } from '@syncfusion/ej2-angular-richtexteditor';
import { DataUtil } from '@syncfusion/ej2-data';
import { WooPromotionVariableModalComponent } from '../../system-variables/woo-promotion-variable-modal/woo-promotion-variable-modal.component';


@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css'],
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, FileManagerService,]
})
export class UserEditComponent implements OnInit {
  // user_id: number;
  brand_user_update: any;
  user_levels: any;
  brands: any;


  public cValue: string = "#1de4d7";
  @Input('UserForm') UserForm: any;
  @Input('value')
    set value(value: any) {
        this.cValue = value;
    }

  @Input() item_id?; // impliments on changes.
  @Input() item_data?; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'full'; // side | abstract | full

  @ViewChild('UserForm') form: any;
  updateBrandUserClick;

  @ViewChild('defaultRTE', {static: false}) defaultRTE;
  @ViewChild('emailSignatureTemplate', {static: false}) emailSignatureTemplate;
  
  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  brand_types: any;
  brand: any;
  @Input() user_id: number;
  stripped: any;
  filenameselected: any;
  baseUploadURL: string;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;



  // Text editor Settings
  public simpleToolBar: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable',
    {
      tooltipText: 'Insert Image',
      undo: true,
      click: this.onClickPromotionButton.bind(this),
      template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
    }
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']    

};
  



    public pasteCleanupSettings: object = {
      prompt: true,
      plainText: false,
      keepFormat: false,
      deniedTags: ['a'],
      deniedAttrs: ['class', 'title', 'id'],
      allowedStyleProps: ['color', 'margin', 'font-size']
  }; 

  public simpleToolBar_emailSignatureTemplateEditor: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    {
      tooltipText: 'Insert Widget',
      undo: true,
      click: this.onClickPromotionButton_emailSignatureTemplate.bind(this),
      template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
    },
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };  




  current_user_paragraphs: any;
  job_owner_client_paragraphs: any;
  model: UserFull;
  brand_id: any;
  email_signature_HTML_rendered: any;
  subject_template_doc: any;


  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router:Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService,
    private _location: Location,
    public gfunc: GlobalFunctionsService,
    private sanitizer: DomSanitizer,
  ) { 

  
    this.user_id = +this.route.snapshot.paramMap.get('user_id');
 
    // Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

  }

  ngOnInit() {

    if(this.item_id >= 1){
      this.user_id = this.item_id;
    }


    this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + this.user_id; // no trailing slash

    this.model = new UserFull(); // loads the Trace model into the model vars for the form.
this.model.email_signature_HTML_rendered = '';
    this.getBrandUser(this.user_id);
    this.getFormUserLevels();
    this.getBrands();
    this.getBrand_owner_Q(94) // load the owner variables 

  }





   // MODAL view a component
   openModalWithComponent() {
    const initialState = {
      title: 'Upload Image / Photo',
      item_id: 1010,
      user_id: this.user_id,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UserAvitarModalUploadComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.user_id = this.user_id;
   // this.bsModalRef.content.brand_id = this.brand_id;
    this.bsModalRef.content.item_id = this.user_id;
    this.bsModalRef.content.closeBtnName = 'Close';
    // subscribed to the emitter and get the value.
        //   this.bsModalRef.content.action.take(1).subscribe((value) => {
        // // console.log(value); // here you will get the value of the file
        // // Remove the "uploads/" part from the filename.
        // this.filenameselected = value;
        // this.stripped = this.filenameselected.replace('uploads/', '');
        // // this.model.main_image = this.stripped; // works for simple add not update.
        // // console.log(this.stripped);
        // // console.log(this.model);
        // this.form.photo = this.stripped;
        // // this.form.reset();
        // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
        // this.form.controls['photo'].patchValue(this.form.photo);
        // });


  this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_P.bind(this)); /// THIS WORKLED // when clicked.....

   }

// :: Parent / Child modal test
public addFileNameFromModal_P(filename) {

  // this.model.logo = filename;
  this.form.controls['photo'].patchValue(filename); // works by setting the new frorm value from parent modal.

// this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};
// Database Functions
getBrandUser(user_id) {
  this._demoService.getBrandUser(user_id).subscribe(
     data => { 
      let res = data[0]
      res.is_primary_contact = Number(res.is_primary_contact) === 1;
      this.brand_user_update = data;

      this.brand_id = res.user_id;
      this.current_user_paragraphs = data;
    
      if(data[0].email_signature_HTML){
      //  this.email_signature_HTML_rendered =  this.runReplaceAllVariables_UserEmailSignature(data[0].email_signature_HTML, res) // this will need to be rendered and then decoded for view.
      //  this.model.email_signature_HTML_rendered = this.email_signature_HTML_rendered // this will need to be rendered and then decoded for view.
      }
 
    

      
    },
     err => console.error(err),
     () => {
    

     
      console.log('done loading user for update')
    }
   );
 }


 loadEmailSignatureAndRender(str, model){
  return this.email_signature_HTML_rendered =  this.runReplaceAllVariables_UserEmailSignature(str, model) // this will need to be rendered and then decoded for view.
  // this.model.email_signature_HTML_rendered = this.email_signature_HTML_rendered // this will need to be rendered and then decoded for view.
 }

// update was here for onit but moved for onchange
updateBrandUser(model) {
  const updateModel = {
    ...model,
    email_signature_HTML_rendered: this.email_signature_HTML_rendered,
    is_primary_contact: model.is_primary_contact ? 1 : 0
  };
this._demoService.updateBrandUser(updateModel).subscribe(
   data => {
    console.log(updateModel);
     // this.trace_candidate_update = data;
   this.toastr.success('User Updated');
   // Subject to reload the manager component parent.
  // BrandUserManagerComponent.returned.next(false);
     return true;
   },
   error => {
     console.error('Error saving User!');
    return console.log(error);
   }
  // err => console.error(err),
  // () => console.log('done updates')
);
}

      // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
      getHtml(html){
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    
        // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
      // WORKS as I created my own function from this articel == pretty well convers
      transform2(value: any, args?: any): any {
        const doc = new DOMParser().parseFromString(value, 'text/html');
        return doc.documentElement.textContent;
      }


getFormUserLevels() {
  this._demoService.getFormUserLevels().subscribe(
     data2 => { this.user_levels = data2;
      console.log(data2);
   },
     err => console.error(err),
     () => console.log('done loading User Levels')
   );
 }


 getBrands() {
  this._demoService.getBrands().subscribe(
     data2 => { this.brands = data2;
     // console.log(data2);
   },
     err => console.error(err),
     () => console.log('done loading User Brands')
   );
 }


   // to router navigate back
   public goBack() {
    this._location.back();
  }
  
  
  userView(user_id) {
    // this.router.navigate(['/admin/brands/users/view/' + user_id + '']);
    this.gfunc.globalUserView(user_id);
  }
  
  userEdit(user_id) {
    // this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
    this.gfunc.globalUserEdit(user_id);
  }



  getBrand_owner_Q(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        // this.brand_data = data;

        let res = data[0];
        this.job_owner_client_paragraphs = DataUtil.parse.parseJson(data);

      },
      (err) => console.error(err),
      () => console.log('Brand Owner Loaded.')
    );
  }



  runReplaceAllVariables_UserEmailSignature(str, model){
  

      const rendered_result = str

    
    // owner Variables
               .replaceAll('${job_owner_name}', this.job_owner_client_paragraphs[0].name)
               .replaceAll('${job_owner_name}', this.job_owner_client_paragraphs[0].name)
               .replaceAll('${job_owner_name_upper}', this.job_owner_client_paragraphs[0].name)
    
               .replaceAll('${job_owner_phone}', this.job_owner_client_paragraphs[0].phone)
               .replaceAll('${job_owner_address_1}', this.job_owner_client_paragraphs[0].address_1)
               .replaceAll('${job_owner_address_2}', this.job_owner_client_paragraphs[0].address_2)
               .replaceAll('${job_owner_suburb}', this.job_owner_client_paragraphs[0].suburb)
               .replaceAll('${job_owner_state}', this.job_owner_client_paragraphs[0].state)
               .replaceAll('${job_owner_postcode}', this.job_owner_client_paragraphs[0].postcode)
               .replaceAll('${job_owner_country}', this.job_owner_client_paragraphs[0].country)
               .replaceAll('${job_owner_brand_type_id}', this.job_owner_client_paragraphs[0].brand_type_id)
               .replaceAll('${job_owner_notes}', this.job_owner_client_paragraphs[0].brand_notes)
               .replaceAll('${job_owner_fax}', this.job_owner_client_paragraphs[0].fax)
               .replaceAll('${job_owner_email}', this.job_owner_client_paragraphs[0].email)
               .replaceAll('${job_owner_website}', this.job_owner_client_paragraphs[0].website)
               .replaceAll('${job_owner_postal_address_1}', this.job_owner_client_paragraphs[0].postal_address_1)
               .replaceAll('${job_owner_postal_address_2}', this.job_owner_client_paragraphs[0].postal_address_2)
               .replaceAll('${job_owner_postal_suburb}', this.job_owner_client_paragraphs[0].postal_suburb)
               .replaceAll('${job_owner_postal_state}', this.job_owner_client_paragraphs[0].postal_state)
               .replaceAll('${job_owner_postal_postcode}', this.job_owner_client_paragraphs[0].postal_postcode)
               .replaceAll('${job_owner_postal_country}', this.job_owner_client_paragraphs[0].postal_country)
               .replaceAll('${job_owner_myob_id}', this.job_owner_client_paragraphs[0].myob_id)
               .replaceAll('${job_owner_accounts_email_address}', this.job_owner_client_paragraphs[0].accounts_email_address)
               .replaceAll('${job_owner_brand_type}', this.job_owner_client_paragraphs[0].brand_type_id)
    
    // User Variables.
               .replaceAll('${f_user_first_name}',  this.current_user_paragraphs[0].first_name)
               .replaceAll('${f_user_name_surname}', this.current_user_paragraphs[0].surname)
               .replaceAll('${f_user_surname}', this.current_user_paragraphs[0].surname)
    
               .replaceAll('${f_user_name}', this.current_user_paragraphs[0].username)
               .replaceAll('${f_user_name_upper}', this.current_user_paragraphs[0].username)
               .replaceAll('${f_user_phone}', this.current_user_paragraphs[0].phone)
               .replaceAll('${f_user_address_1}', this.current_user_paragraphs[0].address_1)
               .replaceAll('${f_user_address_2}', this.current_user_paragraphs[0].address_2)
               .replaceAll('${f_user_suburb}', this.current_user_paragraphs[0].suburb)
               .replaceAll('${f_user_state}', this.current_user_paragraphs[0].state)
               .replaceAll('${f_user_postcode}', this.current_user_paragraphs[0].postcode)
               .replaceAll('${f_user_country}', this.current_user_paragraphs[0].country)
               .replaceAll('${f_user_brand_type_id}', this.current_user_paragraphs[0].brand_type_id)
               .replaceAll('${f_user_notes}', this.current_user_paragraphs[0].brand_notes)
               .replaceAll('${f_user_fax}', this.current_user_paragraphs[0].fax)
               .replaceAll('${f_user_email}', this.current_user_paragraphs[0].email_address)
               .replaceAll('${f_user_website}', this.current_user_paragraphs[0].website)
               .replaceAll('${f_user_postal_address_1}', this.current_user_paragraphs[0].postal_address_1)
               .replaceAll('${f_user_postal_address_2}', this.current_user_paragraphs[0].postal_address_2)
               .replaceAll('${f_user_postal_suburb}', this.current_user_paragraphs[0].postal_suburb)
               .replaceAll('${f_user_postal_state}', this.current_user_paragraphs[0].postal_state)
               .replaceAll('${f_user_postal_postcode}', this.current_user_paragraphs[0].postal_postcode)
               .replaceAll('${f_user_postal_country}', this.current_user_paragraphs[0].postal_country)
    
   
    // hide anything null or undefined.
    .replaceAll('${undefined}', '')
    .replaceAll('${null}', '')
    .replaceAll('undefined', '') // makes all undefined print empty
    .replaceAll('null', '') // makes all undefined print empty
    .replaceAll('Invalid date', '') // makes all undefined print empty
    
    this.toastr.success('Results Rendered')

    return rendered_result;
    }
    





    // BOF Image Modal - for rich text editor
    public onClickPromotionButton() {
      // this.rteObj.focusIn();
      this.openModalWithComponent_Promotion();
  }
  
  
  public onClickPromotionButton_emailSignatureTemplate() {
    // this.rteObj.focusIn();
    this.openModalWithComponent_Promotion_emailSignatureTemplate();
  }


    // MODAL view a component
    openModalWithComponent_Promotion_emailSignatureTemplate() {
      const initialState = {
        title: 'Select System Variable/Item(s) - Choose for Templates',
        item_id: 1010,
        brand_id: this.gfunc.sessionBrandId,
        promotion_id: '',
        template_model: null,
        size: 'lg',
        backdrop: true,
        IgnoreBackdropClick: false,
        editorID: "emailSignatureTemplate"
      };
      this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
      // sets the var to in the component model
      
      this.bsModalRef.content.editorID = 'emailSignatureTemplate',
      
      // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
    
  
      this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.brand_model = this.brand;
      // this.bsModalRef.content.promotion_id = this.promotion_id;
      this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
      // subscribed to the emitter and get the value.
                //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                // // console.log(value); // here you will get the value of the file
                // // Remove the "uploads/" part from the filename.
                // this.filenameselected = value;
                // this.stripped = this.filenameselected.replace('uploads/', '');
                // // this.model.main_image = this.stripped; // works for simple add not update.
                // // console.log(this.stripped);
                // // console.log(this.model);
                // this.form.logo = this.stripped;
                // // this.form.reset();
                // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                // this.form.controls['logo'].patchValue(this.form.logo);
                
                // });
                // modal component method clickOK to run local method addFileNameFromModal
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
            
                // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
  
                
                // this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.action.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                // this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  

                
                this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
  
                this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                
     


                // Try wrapping an image tag around the image before inserting.
                // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
  
                // return this.modalRef.content.onClose;
  
    }
  
  
       // MODAL view a component
       openModalWithComponent_Promotion() {
        const initialState = {
          title: 'Select System Variable/Item(s) - Choose for Templates',
          item_id: 1010,
          brand_id: this.gfunc.sessionBrandId,
          promotion_id: '',
          template_model: null,
          size: 'lg',
          backdrop: true,
          IgnoreBackdropClick: false,
        };
        this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
        // sets the var to in the component model
        this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
        this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
        this.bsModalRef.content.closeBtnName = 'Close';
        this.bsModalRef.content.brand_model = this.brand;
        // this.bsModalRef.content.promotion_id = this.promotion_id;
        this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
        // subscribed to the emitter and get the value.
                  //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                  // // console.log(value); // here you will get the value of the file
                  // // Remove the "uploads/" part from the filename.
                  // this.filenameselected = value;
                  // this.stripped = this.filenameselected.replace('uploads/', '');
                  // // this.model.main_image = this.stripped; // works for simple add not update.
                  // // console.log(this.stripped);
                  // // console.log(this.model);
                  // this.form.logo = this.stripped;
                  // // this.form.reset();
                  // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                  // this.form.controls['logo'].patchValue(this.form.logo);
                  
                  // });
                  // modal component method clickOK to run local method addFileNameFromModal
                  // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
              
                  // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
    
                  this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                  this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                  this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                  this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                  this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
    
                  
                  // Try wrapping an image tag around the image before inserting.
                  // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
    
                  // return this.modalRef.content.onClose;
    
      }
  
  
  
  
     // this willl have to be avariable.
          // :: Parent / Child modal test
          public insertPromotionFromModal(fileurl) {
            // alert('Clicked Insert');
      
      
                    // Try wrapping an image tag around the image before inserting.
                    // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                    // auto inserts the variable name of theat which was sent.
                    let insert_tag = 'NOT USED -- {{' + fileurl + '}}'
      
            // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
            this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
            // InsertHtml.Insert(document, document.createTextNode(fileurl));
            InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            // InsertHtml.Insert(document, document.createElement('image') )
      
      
            // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
      
      
            // insertImage(fileurl);
      
            // has to be correct form name
          // this.modalRef.hide();
          // console.log('Added External Recipeint.');
          // this.toastr.info('External Recipient Added');
          };
    
    
          public insertStrFromModal(fileurl) {
            // alert('Clicked Insert');
      
      
                    // Try wrapping an image tag around the image before inserting.
                    // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                    // auto inserts the variable name of theat which was sent.
                    let insert_tag = '' + fileurl + ''
      
            // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
            this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
            // InsertHtml.Insert(document, document.createTextNode(fileurl));
            InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            // InsertHtml.Insert(document, document.createElement('image') )
      
      
            // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
      
      
            // insertImage(fileurl);
      
            // has to be correct form name
          // this.modalRef.hide();
          // console.log('Added External Recipeint.');
          // this.toastr.info('External Recipient Added');
          };
    
    
          public insertVariableFromModal(fileurl) {
            // alert('Clicked Insert');
      
      
                    // Try wrapping an image tag around the image before inserting.
                    // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                    // auto inserts the variable name of theat which was sent.
                  //  pps
                    // let insert_tag = '${' + fileurl + '}'
  
                    // sharmans
                    let insert_tag = fileurl;
  
  
            // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
            this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
            // InsertHtml.Insert(document, document.createTextNode(fileurl));
            InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            // InsertHtml.Insert(document, document.createElement('image') )
      
      
            // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
      
      
            // insertImage(fileurl);
      
            // has to be correct form name
          // this.modalRef.hide();
          // console.log('Added External Recipeint.');
          // this.toastr.info('External Recipient Added');
          };
  
  
  
  
          public insertImageQRFromModal(fileurl) {
            // alert('Clicked Insert');
      
      
                    // Try wrapping an image tag around the image before inserting.
                    // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
      
                    // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="https://ppsdistrohub.nickbowen.com.au/APP_PHP/uploads/' + fileurl + '" >'
  
                                    // april 28 2023 - now in assets of brand.
                  let link = this.gfunc.baseUploadURL_BrandAssets + '/' + this.brand_id + '/qrcodes/' + fileurl;
                  let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="'+ link + '" >'
    
                    // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src=" https://ppsdistrohub.nickbowen.com.au/APP_PHP/uploads/' + fileurl + '" >'
      
            // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
            this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
            // InsertHtml.Insert(document, document.createTextNode(fileurl));
            InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            // InsertHtml.Insert(document, document.createElement('image') )
      
      
            // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
      
      
            // insertImage(fileurl);
      
            // has to be correct form name
          // this.modalRef.hide();
          // console.log('Added External Recipeint.');
          // this.toastr.info('External Recipient Added');
          };




  // :: Parent / Child modal test
  public insertImageFromModal(fileurl) {
    // alert('Clicked Insert');


            // Try wrapping an image tag around the image before inserting.
            // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

            let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="' + fileurl + '" >'

    // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
    this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
    // InsertHtml.Insert(document, document.createTextNode(fileurl));
    InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
    // InsertHtml.Insert(document, document.createElement('image') )



    

    // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 


    // insertImage(fileurl);

    // has to be correct form name
  // this.modalRef.hide();
  // console.log('Added External Recipeint.');
  // this.toastr.info('External Recipient Added');
  };


  public insertImageFromModal_EditorID(fileurl) {
   
    // Need to create the new button in HTML widget to click.
    console.log(JSON.stringify(fileurl))
    let editorID = fileurl.editorID
    let insert_variable = fileurl.fileurl
   
    // alert('Clicked Insert');


            // Try wrapping an image tag around the image before inserting.
            // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

            // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="' + fileurl + '" >'
            let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="' + insert_variable + '" >'


            if (editorID == 'defaultRTE'){
                          // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
            this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
            // InsertHtml.Insert(document, document.createTextNode(fileurl));
            InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            // InsertHtml.Insert(document, document.createElement('image') )
             }
          
             if (editorID == 'emailSignatureTemplate'){
              this.emailSignatureTemplate.focusIn(); // these two lines work for RichTextEditor
              InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
             }



                  // // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
                  // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
                  // // InsertHtml.Insert(document, document.createTextNode(fileurl));
                  // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                  // // InsertHtml.Insert(document, document.createElement('image') )



    

    // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 


    // insertImage(fileurl);

    // has to be correct form name
  // this.modalRef.hide();
  // console.log('Added External Recipeint.');
  // this.toastr.info('External Recipient Added');
  };


    // END OF IMAGE modal 


  // Now workes for multiple editors on a page... few!! 11pm 2/12/23
  public insertVariableFromModal_EditorID(fileurl) {
    // alert('Clicked Insert');

    // console.log(JSON.stringify(fileurl))
    let editorID = fileurl.editorID
    let insert_variable = fileurl.fileurl

    this.toastr.info('Variable Inserted: ' + insert_variable)

    // this.toastr.info('editorID: ' + editorID)

            // Try wrapping an image tag around the image before inserting.
            // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
            // auto inserts the variable name of theat which was sent.
          //  pps
            // let insert_tag = '${' + fileurl + '}'

            // sharmans
    // let insert_tag = fileurl;
    // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
    // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI


        // // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
        // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
        // // InsertHtml.Insert(document, document.createTextNode(fileurl));
        // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
        // // InsertHtml.Insert(document, document.createElement('image') )

        // // Need an if statment and to get the Editor ID , to have muliple occurannces on one page.

      
    // if (editorID == 'emailSubjectTemplate'){  
    //   // Now adds to the subject
    //                 let currentValue =   this.form.controls['email_subject_primary'].value;
    //                 let newValue = '';
    //                 if(currentValue == null){
    //                   newValue = insert_variable;
    //                 }else{
    //                   newValue = currentValue + ' ' + insert_variable;
    //                 }
    //                 this.form.controls['email_subject_primary'].patchValue(newValue);
    //    }

    //               if (editorID == 'emailSubjectTemplatePrivate'){  
    //                 // Now adds to the subject
    //                 let currentValue =   this.form.controls['email_subject_private'].value;
    //                 let newValue = '';
    //                 if(currentValue == null){
    //                   newValue = insert_variable;
    //                 }else{
    //                   newValue = currentValue + ' ' + insert_variable;
    //                 }
    //                 this.form.controls['email_subject_private'].patchValue(newValue);
    //               }

                      
    //             if (editorID == 'emailTemplate'){
    //               this.emailTemplateEditor.focusIn(); // these two lines work for RichTextEditor
    //               InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
    //               } 
                  
    //               if (editorID == 'emailTemplatePrivate'){
    //                 this.emailTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
    //                 InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
    //                 }    

    //                   // NoteTemplate Editor.
    //              if (editorID == 'noteTemplate'){
    //               this.noteTemplateEditor.focusIn(); // these two lines work for RichTextEditor
    //               InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
    //              }

    //                   // NoteTemplate Editor.
    //                   if (editorID == 'noteTemplatePrivate'){
    //                     this.noteTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
    //                     InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
    //                }
                    

   if (editorID == 'defaultRTE'){
    this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
    InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
   }

   if (editorID == 'emailSignatureTemplate'){
    this.emailSignatureTemplate.focusIn(); // these two lines work for RichTextEditor
    InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
   }

    // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 


    // insertImage(fileurl);

    // has to be correct form name
  // this.modalRef.hide();
  // console.log('Added External Recipeint.');
  // this.toastr.info('External Recipient Added');
  };




  setColour(value2){
    console.log('SetColour: ' + value2)
    this.UserForm.log_type_colour.value = this.UserForm.colourpicker.value
  }




}

